import ReactQuill from 'react-quill';

const { Quill } = ReactQuill;
const Inline = Quill.import('blots/inline');

// A quantity at the right edge of the text, so the quantities of a list are one above the
// other (e.g. the materials of a material offer). Rendered to the offer PDF by
// Application/Services/Offers/Common/OfferTextRenderer.cs.
class QuantityBlot extends Inline {
  static blotName = 'quantity';

  static tagName = 'span';

  static className = 'ql-quantity';

  static formats(): boolean {
    return true;
  }
}

export default QuantityBlot;
